import React from "react";
import Box from "@mui/material/Box";
import { makeStyles } from "@mui/styles";
import { Link } from "react-router-dom"; // Import Link from react-router-dom

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: "0.9rem",
    textAlign: "center",
    marginTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  spacerSmall: {
    display: "inline-block",
    width: theme.spacing(1),
  },
  spacerMedium: {
    display: "inline-block",
    width: theme.spacing(2),
  },
}));

function AuthFooter(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {props.type === "signup" && (
        <>
          {props.showAgreement && (
            <Box mb={2}>
              By signing up, you are agreeing to our{" "}
              <Link to={props.termsPath}>Terms of Service</Link>{" "}
              and{" "}
              <Link to={props.privacyPolicyPath}>Privacy Policy</Link>.
            </Box>
          )}

          {props.signinText}
          <span className={classes.spacerSmall} />
          <Link to={props.signinPath}>{props.signinAction}</Link>
        </>
      )}

      {props.type === "signin" && (
        <>
          <Link to={props.signupPath}>{props.signupAction}</Link>

          {props.forgotPassAction && (
            <>
              <span className={classes.spacerMedium} />
              <Link to={props.forgotPassPath}>{props.forgotPassAction}</Link>
            </>
          )}
        </>
      )}

      {props.type === "forgotpass" && (
        <>
          {props.signinText}
          <span className={classes.spacerSmall} />
          <Link to={props.signinPath}>{props.signinAction}</Link>
        </>
      )}
    </div>
  );
}

export default AuthFooter;